var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":_vm.id,"name":_vm.name,"type":"hidden"},domProps:{"value":_vm.chosenVariant ? _vm.chosenVariant : null}})}
var staticRenderFns = []

export { render, staticRenderFns }